import { connect } from 'react-redux';

import {
  GET_PLACE_DETAIL,
  EDIT_PLACE_SERVICES,
  EDIT_PLACE_PARKING_SERVICE,
  RESET_PLACE_DETAILS,
} from 'store/place/actionTypes';

import ConveniencesServices from './ConveniencesServices';

const mapStateToProps = (state) => ({
  isLoadingGetSetting: state.Setting.isLoadingGetSetting,
  isLoadingGetPlaceDetail: state.Place.isLoadingGetPlaceDetail,
  isLoadingEditPlaceService: state.Place.isLoadingEditPlaceService,
  isLoadingEditPlaceParkingService: state.Place.isLoadingEditPlaceParkingService,

  setting: state.Setting.setting,
  placeDetail: state.Place.placeDetail,
});

const mapDispatchToProps = (dispatch) => ({
  actionGetPlaceDetail: (payload) => dispatch({
    type: GET_PLACE_DETAIL,
    payload,
  }),

  actionPutPlaceServices: (payload) => dispatch({
    type: EDIT_PLACE_SERVICES,
    payload,
  }),

  actionPutPlaceParkingService: (payload) => dispatch({
    type: EDIT_PLACE_PARKING_SERVICE,
    payload,
  }),

  actionResetPlaceDetail: () => dispatch({
    type: RESET_PLACE_DETAILS,
  }),
});

export default connect(mapStateToProps, mapDispatchToProps)(ConveniencesServices);
